// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RangedDatePickerWithOptions{display:inline-block}.RangedDatePickerWithOptions .selection-header{display:inline-block}
`, "",{"version":3,"sources":["webpack://./src/components/rangeddatepicker/RangedDatePickerWithOptions.scss"],"names":[],"mappings":"AACA,6BACE,oBAAqB,CADvB,+CAGI,oBAAqB","sourcesContent":["\n.RangedDatePickerWithOptions {\n  display: inline-block;\n  .selection-header {\n    display: inline-block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
